
import { useState } from "react";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { SaveAdditionalNotesTemplateDialog } from "./SaveAdditionalNotesTemplateDialog";
import { LoadAdditionalNotesTemplateDialog } from "./LoadAdditionalNotesTemplateDialog";
import { BookOpen, Save, Loader2 } from "lucide-react";

interface AdditionalNotesProps {
  notes: string;
  setNotes: (notes: string) => void;
}

export function AdditionalNotes({ notes, setNotes }: AdditionalNotesProps) {
  const [showSaveDialog, setShowSaveDialog] = useState(false);
  const [showLoadDialog, setShowLoadDialog] = useState(false);

  const handleLoadTemplate = (templateNotes: string) => {
    setNotes(templateNotes);
  };

  return (
    <div className="space-y-3">
      <div className="flex items-center justify-between">
        <Label htmlFor="notes">Additional Notes</Label>
        <div className="flex items-center gap-2">
          <Button
            type="button"
            variant="outline"
            size="sm"
            onClick={() => setShowLoadDialog(true)}
            className="h-8 px-3 text-xs"
          >
            <BookOpen className="h-3 w-3 mr-1" />
            Load Template
          </Button>
          {notes.trim() && (
            <Button
              type="button"
              variant="outline"
              size="sm"
              onClick={() => setShowSaveDialog(true)}
              className="h-8 px-3 text-xs"
            >
              <Save className="h-3 w-3 mr-1" />
              Save Template
            </Button>
          )}
        </div>
      </div>
      
      <Textarea 
        id="notes"
        value={notes}
        onChange={(e) => setNotes(e.target.value)}
        placeholder="Enter any additional notes or instructions"
        className="resize-none h-20"
      />

      {/* Save Template Dialog */}
      <SaveAdditionalNotesTemplateDialog
        isOpen={showSaveDialog}
        onClose={() => setShowSaveDialog(false)}
        notes={notes}
        onTemplateSaved={() => {
          // Template saved successfully
        }}
      />

      {/* Load Template Dialog */}
      <LoadAdditionalNotesTemplateDialog
        isOpen={showLoadDialog}
        onClose={() => setShowLoadDialog(false)}
        onLoadTemplate={handleLoadTemplate}
      />
    </div>
  );
}
